"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Headline = (0, _styledComponents.default)(_Text.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  text-transform: uppercase;\n  line-height: 0.8em;\n"], ["\n  text-transform: uppercase;\n  line-height: 0.8em;\n"])));
Headline.displayName = 'Headline';
Headline.defaultProps = {
  as: 'h1',
  color: 'black',
  fontSize: [18, 22],
  fontFamily: 'mrEaves',
  fontWeight: 'bold'
};
var _default = Headline;
exports.default = _default;
var templateObject_1;